import GalleryImageGrid from "./sections/GalleryImageGrid.jsx";
import GallerySelection from "./GallerySelection";
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Edit } from "@mui/icons-material";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";

import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Button, IconButton, Paper, Typography } from "@mui/material";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, Modal, PageTitle } from "../../../../shared/ui/common/index.js";
import Search from "../../../../shared/ui/common/search.jsx";
import CustomeLayout from "../../../../shared/ui/customeTable.jsx";
import DataFetcher from "../../../../shared/api/index.js";
import Filters from "../../../../shared/ui/filters/index.jsx";


import { GET_ALL_GALLERY } from "../../../../shared/api/endpoints.js";
import ImageGalleryEdit from "./modal.jsx";
import UploadImageGallery from "./uploadModal.jsx";
const GalleryManager = ({ choosable = false, setSelceted }) => {
  const { token } = useSelector((state) => state.user);

  const [openCreate, setOpenCreate] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [viewType, setViewType] = useState("پنجره ای");

  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [reset, setReset] = useState(1);
  const [selected, setSelected] = useState([]);
  const [applySearch, setApplySearch] = useState("");
  const [openEdit, setOpenEdit] = useState(false);

  const [editingData, setEditingData] = useState({});
  const [applyfilter, setApplyfilter] = useState("");
  const [loading2, setLoading2] = useState(false);
  const [refreshData, setRefresh] = useState(0);
  const [search, setsearch] = useState("");
  const [sumbitSearch, setSumbitSearch] = useState("");
  const [limit, setLimit] = useState(50);
  const [filter, setFilter] = useState([]);
  const [allRows, setAllRows] = useState([]);
  const [sort, setSort] = useState({});
  const { hasMore, loading, errors, allData, CurrentPage, metaData, header, setting } =
    DataFetcher(
      limit,
      page,
      sort,
      GET_ALL_GALLERY,
      filter,
      true,
      refreshData,
      sumbitSearch,
      viewType === "پنجره ای" ? 2 : 1,
      false, undefined, undefined,
      viewType === "پنجره ای" ? "infinite" : undefined
    );
  useEffect(() => {
    setAllRows(allData);
  }, [allData]);

  const observer = useRef();
  const requestedPage = useRef(null);
  useEffect(() => { requestedPage.current = null; }, [refreshData, sort, filter, sumbitSearch, limit, viewType]);
  useEffect(() => () => observer.current?.disconnect(), []);
  const applyGallerySearch = (value) => { setPage(1); setSumbitSearch(value); };
  const lastInvoiceElement = useCallback(
    (node) => {
      if (observer.current) observer.current.disconnect();
      if (loading || errors) return;
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore && requestedPage.current !== page) {
          requestedPage.current = page;
          setPage((page) => page + 1);
        }
      }, { rootMargin: "300px" });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore, errors, page]
  );

  const handleReset = () => {
    setLoading2(true);
    /*     axiosInstance
      .delete(`${baseUrl}/${RESET_GALLERY}`, configReq(token))
      .then((res) => {
        setLoading2(false);

        toast.success("با موفقیت حذف شد");
        setReset((r) => r + 1);
        setOpenDelete(false);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message);
        setLoading2(false);
        if (err.response.status === 401) {
          dispatch(logout());
        }
      }); */
  };

  return (
    <>
      {!choosable && (
        <PageTitle title={"گالری تصاویر"} hideTitle={!choosable} />
      )}

      <div className="md:mx-3 mx-1">
        <Paper
          sx={{
            border: "1px solid #dbdfea",
            mb: 1,
            px: choosable ? 1 : 2,
            pb: 1,
            pt: "12px",
            width: "100% !important",
          }}
          elevation={0}
        >
          <div className="flex md:gap-4 gap-1 flex-wrap justify-between">
            <div className="flex flex-wrap gap-4 items-center first-line">
              {" "}
              {!choosable && (
                <div className="sm:w-[11.25rem] w-full">
                  <Dropdown
                    title=" نمایش به صورت"
                    data={["پنجره ای", "ردیفی"]}
                    value={viewType}
                    change={(e) => {
                      setViewType(e);
                      setPage(1);
                      setRefresh((r) => r + 1);
                      setSort({});
                    }}
                  />
                </div>
              )}
              <Filters
                limit={limit}
                setLimit={setLimit}
                headers={header}
                setFilter={setFilter}
                filter={filter}
                setPage={setPage}
                loading={loading}
              />{" "}
            </div>{" "}
            {!choosable && (
              <div className="flex  gap-3 flex-wrap justify-end">
                {/*          {userPermissions?.gallery?.cleanup && !choosable && (
                  <Button
                    onClick={() => setOpenDelete(true)}
                    color="error"
                    variant="contained"
                  >
                    <DeleteOutlineOutlinedIcon />
                    حذف تصاویر بدون استفاده
                  </Button>
                )} */}
                {!choosable && (
                  <Button
                    onClick={() => setOpenCreate(true)}
                    color="primary"
                    variant="contained"
                  >
                    <AddAPhotoIcon sx={{ mr: "4px" }} />
                    افزودن تصویر جدید
                  </Button>
                )}
              </div>
            )}
          </div>
        </Paper>
        <Paper
          sx={{
            border: "1px solid #dbdfea",
            py: 2,
            width: "100% !important",
            mt: 1,
          }}
          elevation={0}
        >
          {viewType === "پنجره ای" ? (
            <>
              <Box className="relative grid md:grid-cols-2 gap-y-2 px-3 pb-5">
                <div className="flex items-center md:justify-start justify-between">
                  <div className="flex items-center gap-2">
                    <Typography
                      sx={{ fontSize: { md: "1rem !important", xs: "0.8rem" } }}
                      variant="h6"
                    >
                      گالری تصاویر
                    </Typography>
                    <Typography
                      sx={{
                        borderLeft: "1px solid #dbdfea",
                        fontSize: "0.83rem !important",
                        color: "#001ee4",
                      }}
                      className="px-2 mx-2"
                      variant="body2"
                    >
                      تعداد نتایج : {metaData?.total} مورد
                    </Typography>
                    <div className="hidden md:flex justify-center mr-4">
                      {" "}
                      <div className="md:w-[350px] md:mb-0 mb-4 w-full ">
                        <Search
                          setSearch={setsearch}
                          search={search}
                          setApplySearch={applyGallerySearch}
                        />
                      </div>
                    </div>
                  </div>{" "}
                  <div className="flex md:hidden  justify-end">
                    <IconButton
                      sx={{
                        background: "#f0f0f0 !important",
                        width: "1.3rem !important",
                        padding: "2px !important",
                        height: "1.3rem !important",
                        fontSize: "1.5rem !important",
                      }}
                      onClick={() => {
                        setsearch("");
                        setSumbitSearch("");
                        setRefresh((r) => r + 1);
                        setPage(1);
                      }}
                    >
                      <RefreshIcon sx={{ color: "#001ee4" }} />
                    </IconButton>
                  </div>
                </div>

                <div className="flex md:hidden justify-center">
                  {" "}
                  <div className="md:w-[350px] md:mb-0 mb-4 w-full ">
                    <Search
                      setSearch={setsearch}
                      search={search}
                      setApplySearch={applyGallerySearch}
                    />
                  </div>
                </div>
                <div className="hidden md:flex items-center justify-end gap-2">
                  <IconButton
                    sx={{
                      background: "#f0f0f0 !important",
                      width: "1.3rem !important",
                      padding: "2px !important",
                      height: "1.3rem !important",
                      fontSize: "1.5rem !important",
                    }}
                    onClick={() => {
                      setsearch("");
                      setSumbitSearch("");
                      setRefresh((r) => r + 1);
                      setPage(1);
                    }}
                  >
                    <RefreshIcon sx={{ color: "#001ee4" }} />
                  </IconButton>
                </div>
              </Box>
              <GalleryImageGrid allRows={allRows} lastInvoiceElement={lastInvoiceElement} setSelceted={setSelceted} choosable={choosable} setReset={setReset} setEditingData={setEditingData} setOpenEdit={setOpenEdit} loading={loading} />
            </>
          ) : (
            <>
              <CustomeLayout
                limit={limit}
                setLimit={setLimit}
                setAllRows={setAllRows}
                /*   editApi={EDIT_ACTIVE_GALLERY} */
                title=" گالری تصاویر"
                headers={header}
                setSearch={setsearch}
                search={search}
                page={page}
                total_pages={metaData?.total_pages}
                setApplySearch={(e) => {
                  setPage(1);
                  setSumbitSearch(e);
                  /* setFilter({ ...filter, search: { value: e, type: "lk" } }); */
                }}
                rows={allRows?.filter((items) => items.hidden === false)}
                hasMore={hasMore}
                loading={loading}
                setPage={setPage}
                setting={setting}
                CurrentPage={CurrentPage}
                actions={[
                  {
                    title: "ویرایش",
                    handler: (
                      <>
                        <IconButton
                          onClick={() => {
                            setOpenEdit(true);
                          }}
                        >
                          <Edit sx={{ color: "#ff2000" }} />
                        </IconButton>
                      </>
                    ),
                  },
                ]}
                length={metaData?.total}
                maxHeight={{ lg: "69.5vh", md: "68vh", xl: "74vh" }}
                setSort={(e) => {
                  setPage(1);
                  setSort({ ...sort, ...e });
                }}
                currentRow={(data) => {
                  setEditingData(data);
                }}
                setSelected={setSelected}
                selected={selected}
                setRefresh={setRefresh}
              />
            </>
          )}
        </Paper>
        <Modal
          open={openCreate}
          close={() => {
            setOpenCreate(false);
          }}
          title="افزودن تصویر جدید"
          autoWidth={true}
        >
          <UploadImageGallery
            setAllRows={setAllRows}
            allRows={allRows}
            setOpen={(e) => setOpenCreate(e)}
          />
        </Modal>

        <Modal
          open={openDelete}
          close={() => {
            setOpenDelete(false);
          }}
          title="آیا از حذف تمام عکس های بدون استفاده  اطمینان دارید ؟"
          autoWidth={true}
        >
          <div className="flex items-center flex-wrap justify-between gap-2">
            <Button
              onClick={() => setOpenDelete(false)}
              color="error"
              variant="outlined"
            >
              انصراف
            </Button>{" "}
            <Button onClick={handleReset} color="primary" variant="contained">
              بله
            </Button>
          </div>
        </Modal>
      </div>
      <ImageGalleryEdit
        open={openEdit}
        forEdit={openEdit}
        prevData={editingData}
        setAllRows={setAllRows}
        allRows={allRows}
        close={() => {
          setOpenCreate(false);
          setOpenEdit(false);
          setEditingData({});
        }}
      />
    </>
  );
};

export default function Gallery(props) {
  return props.choosable ? <GallerySelection {...props} /> : <GalleryManager {...props} />;
}
